import { ActionType } from "../action-types";
import { Action } from "../actions";
import { OperatorDto } from "../../dto/postLogin";

export type OperatorState = OperatorDto | null;

const initialState: OperatorState = null;

const operatorReducer = (
  state: OperatorState = initialState,
  action: Action
): OperatorState => {
  switch (action.type) {
    case ActionType.SET_OPERATOR:
      return action.payload;
    default:
      return state;
  }
};

export default operatorReducer;
